import IMask from 'imask';
import {onFind} from "@elements/init-modules-in-scope";

export function init () {
    onFind('.js-input-mask-payment', function(baseElement) {
        IMask(baseElement, {
            mask: [
                {
                    mask: '00/00',
                    maxLength: 4,
                    lazy: true,
                },
            ]
        });
    })
}